<template>
  <div class="combo-dropdown-panel p-relative" :style="dropdownStyles">
    <!-- Phần header của menu khi có grid-->
    <div class="dropdown-header-container" v-if="columnx && columnx.length > 0">
      <table class="dropdown-table" :style="headerStyle">
        <thead class="dropdown-header">
          <tr>
            <th class="selected-container flex item-center justify-center"></th>
            <th
              class="dropdown-header__th"
              v-for="(column, index) in columnx"
              :key="index"
              :title="column.tooltip"
              :style="getThStyle(column)"
            >
              <span>{{ column.title }}</span>
            </th>
          </tr>
        </thead>
      </table>
    </div>
    <div
      ref="menuBodyCon"
      class="dropdown-body-container"
      @scroll.stop="onDropdownMenuScroll"
      :style="dropdownBodyStyle"
    >
      <!-- Phần nội dung grid combo không có column -->
      <ul ref="dropdownItems" class="dropdown-items" v-if="comboType === 1">
        <slot></slot>
      </ul>
      <!--  -->

      <!-- Phần nội dung grid combo có columns và combo tree -->
      <table class="dropdown-table" v-else>
        <tbody ref="dropdownItems" class="dropdown-items">
          <slot></slot>
        </tbody>
      </table>
      <!--  -->
    </div>

    <!-- Hiển thị loading khi chưa có dữ liệu -->
    <div
      class="dropdown--loading p-absolute"
      v-show="loading"
      @click.stop
    >
      <request-loading-indicator
        :height="24"
        :width="24"
        :showOverlay="true"
      ></request-loading-indicator>
    </div>
    <!--  -->
    <!-- Show thông báo khi không có dữ liệu hiển thị -->
    <div class="no-data-display" v-if="showEmptyText" @click.stop>
      <div class="no-data-display__text">Không có dữ liệu</div>
    </div>
    <!--  -->
  </div>
</template>

<script>
export default {
  name: "MsComboBoxDropdown",
  props: {
    /**
     * Loại combo sử dụng để style cột
     */
    comboType: {
      type: Number,
      default: 1,
    },
    /**
     * Số lượng item hiển thị ở dropdown
     */
    maxItemsDisplay: {
      type: Number,
      default: 5,
    },

    /**
     * Các cột của dropdown
     */
    columnx: {
      type: Array,
      default() {
        return [];
      },
    },

    /**
     * Text hiển thị khi không có dữ liệu
     * CreatedBy PDKIEN 09/12/2019
     */
    emptyText: {
      type: String,
      default: "Không có dữ liệu!",
    },

    /**
     * Trạng thái `loading`
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Độ rộng phần dropdown, nếu bằng <=0 hoặc Auto sẽ tự động tính toán
     * CreatedBy PDKIEN 09/12/2019
     */
    dropdownWidth: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Có dữ liệu  hay  không
     * CreatedBy PDKIEN 10/112/2019
     */
    hasData: {
      type: Boolean,
      default: true,
    },
    topx: {
      type: Number,
      default: null,
    },
    leftx: {
      type: Number,
      default: null,
    },
    maxWidthx: {
      type: Number,
      default: null,
    },
    minWidthx: {
      type: Number,
      default: null,
    },
    showEmptyText: {
      type: [String, Boolean],
      default: false,
    },
    marginTopDropdown: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    headerStyle() {
      return {
        width: this.headerWidth + "px",
      };
    },

    headerWidth() {
      let width = 0;
      if (this.columnx && this.columnx.length > 0) {
        for (let index = 0; index < this.columnx.length; index++) {
          const element = this.columnx[index];
          if (element.width) {
            width = width + element.width;
          }
        }
      }
      width += 40;
      return width;
    },
    /**
     * Style cho dropdown
     */
    dropdownStyles() {
      let width = this.headerWidth,
        docWidth = document.body.clientWidth,
        left = this.leftx;
      if (left + width + this.dropdownWidth > docWidth) {
        left = left - (width + left + this.dropdownWidth - docWidth);
      }

      return {
        top: this.topx + "px",
        left: left + "px",
        minWidth: this.minWidthx + "px",
        maxWidth: this.forceMaxWidth ? this.maxWidthx + "px" : null,
        marginTop: this.marginTopDropdown
          ? this.marginTopDropdown + "px"
          : null,
      };
    },

    /**
     * Set lại chiều cao tối đa của dropdown nếu số lượng item hiển thị khác default
     */
    dropdownBodyStyle() {
      let me = this;
      if (me.maxItemsDisplay !== 5) {
        return {
          maxHeight: `${me.maxItemsDisplay * 32}px`,
        };
      }
    },
  },

  methods: {
    /**
     * Hàm lấy style cho th trong table
     * dữ liệu động theo config của dev
     */
    getThStyle(column) {
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.titleAlign,
      };
    },

    /**
     * Xử lý sự kiện click bất kỳ đâu trên document
     */
    onDocumentClick(event) {
      let me = this,
        targetCombo = event.target.closest(".ms-combo"),
        comboEl = me.$parent.$el;

      if (targetCombo !== comboEl) {
        me.$parent.collapse();
      }
    },

    /**
     * Sự kiện khi scroll dropdown menu
     */
    onDropdownMenuScroll(e) {
      let target = e.target;
      // kiểm tra nếu scroll to bottom
      if (target.scrollTop === target.scrollHeight - target.offsetHeight) {
      }
    },

    /**
     * Xử lý sự kiện scroll document
     * - Đóng menu
     */
    onDocumentScroll(event) {
      let me = this,
        comboMenu = event.target.closest(".combo-dropdown-panel");
      if (!comboMenu || comboMenu !== me.$el) {
        me.$parent.collapse();
      }
    },

    onWindowResize() {
      let me = this;
      me.$parent.collapse();
    },

    /**
     * Hàm append dropdown menu vào thẻ body
     * append vào trước phần tử đầu tiên trong thẻ body
     */
    insertBody() {
      let me = this,
        elm = me.$el;
      document.body.insertBefore(elm, document.body.firstChild);
    },
  },
  mounted() {
    let me = this;

    // Append menu vào thẻ body
    me.insertBody();
    // Thêm event click vào document
    // document.addEventListener('click', me.onDocumentClick);

    // document.addEventListener('scroll', me.onDocumentScroll, true);

    // window.addEventListener('resize', me.onWindowResize);
  },
  beforeDestroy() {
    let me = this;

    // me.$el.parentNode.removeChild(me.$el);

    // document.removeEventListener('click', me.onDocumentClick);

    // document.removeEventListener('scroll', me.onDocumentScroll, true);

    // window.removeEventListener('resize', me.onWindowResize);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/controls/_variables.scss";
.d-inline-block {
  display: inline-block;
}

.dropdown-items {
  padding: 0;
  margin: 0;
}
.combo-dropdown-panel {
  min-height: 38px;
  z-index: 999999999;
  position: absolute;
  // margin-top: 2px;
  background-color: #fff;
  border: 1px solid var(--input-normal-border-color);
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
  padding-right: 2px;
  border-radius: 6px;

  .dropdown-table {
    // table-layout: fixed;
    border-collapse: collapse;
    // width: -webkit-fill-available;
    width: 100%;
  }

  .dropdown-header-container {
    background: #f4f5f8;
    .dropdown-header {
      color: #212121;
      height: 38px;
      th {
        padding: 0;
        padding-right: 10px;
        height: 33px;
        font-size: $font-size-base;
      }
    }
  }

  .dropdown-body-container {
    // max-height: 160px;
    padding: 2px 0;
  }

  .dropdown--loading {
    height: 38px;
    bottom: 0;
    left: 0;
    width: 100%;
    cursor: pointer;
    .loading {
      width: 32px;
      height: 38px;
      left: calc(50% - 27px);
      top: auto;
    }
  }

  .no-data-display {
    .no-data-display__text {
      height: 38px;
      line-height: 32px;
      padding: 0 10px;
      text-align: left;
    }
  }

  .com-bottom-button {
    display: table-cell;
    padding: 0 12px 0 34px;
    position: relative;
    cursor: pointer;
    .mi {
      position: absolute;
      left: 10px;
      top: 2px;
    }
    .text {
      display: inline-block;
      color: #35bf22;
    }
    &:not(:last-child):after {
      content: "";
      display: inline-block;
      position: absolute;
      height: 18px;
      width: 1px;
      background: #b9bec5;
      right: 0;
      top: 2px;
    }
  }

  .btn-add-menu {
    padding: 6px 2px;
    background: #ebedf0;
    margin: 0 1px 1px 1px;
  }
}
.selected-container {
  width: 36px;
  height: 20px;
}
</style>